
import CreditsPageComponent from './credits-page-component.vue'

export * from './components';

export {
    CreditsPageComponent
}